import MycawanTooltip from "@/shared/components/generic/tooltip/MycawanTooltip.tsx";
import type { ReactNode } from "react";
import type { TooltipProps } from "@mui/material";

type Properties = TooltipProps & {
  xyOffset?: [number, number];
};
export default function BasicTooltipWithOffset(props: Properties): ReactNode {
  const forwardedProps: TooltipProps = {
    ...props,
    slotProps: {
      popper: {
        modifiers: [
          { name: "offset", options: { offset: props.xyOffset ?? [0, 0] } },
        ],
      },
    },
  };
  return <MycawanTooltip {...forwardedProps} />;
}
